import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "environments/environment";

export interface PeriodicElement {
    name: string;
    position: number;
    weight: number;
    symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
    { position: 1, name: "Hydrogen", weight: 1.0079, symbol: "H" },
    { position: 2, name: "Helium", weight: 4.0026, symbol: "He" },
    { position: 3, name: "Lithium", weight: 6.941, symbol: "Li" },
    { position: 4, name: "Beryllium", weight: 9.0122, symbol: "Be" },
    { position: 5, name: "Boron", weight: 10.811, symbol: "B" },
    { position: 6, name: "Carbon", weight: 12.0107, symbol: "C" },
    { position: 7, name: "Nitrogen", weight: 14.0067, symbol: "N" },
    { position: 8, name: "Oxygen", weight: 15.9994, symbol: "O" },
    { position: 9, name: "Fluorine", weight: 18.9984, symbol: "F" },
    { position: 10, name: "Neon", weight: 20.1797, symbol: "Ne" },
];

const MESSAGES = [
    {
        img: "assets/images/avatars/avatar-1.jpg",
        subject: "Hydrogen",
        content: `Cras sit amet nibh libero, in gravida nulla.
     Nulla vel metus scelerisque ante sollicitudin commodo.`,
    },
    {
        img: "assets/images/avatars/avatar-2.jpg",
        subject: "Helium",
        content: `Cras sit amet nibh libero, in gravida nulla.
     Nulla vel metus scelerisque ante sollicitudin commodo.`,
    },
    {
        img: "assets/images/avatars/avatar-3.jpg",
        subject: "Lithium",
        content: `Cras sit amet nibh libero, in gravida nulla.
     Nulla vel metus scelerisque ante sollicitudin commodo.`,
    },
    {
        img: "assets/images/avatars/avatar-4.jpg",
        subject: "Beryllium",
        content: `Cras sit amet nibh libero, in gravida nulla.
     Nulla vel metus scelerisque ante sollicitudin commodo.`,
    },
    {
        img: "assets/images/avatars/avatar-6.jpg",
        subject: "Boron",
        content: `Cras sit amet nibh libero, in gravida nulla.
     Nulla vel metus scelerisque ante sollicitudin commodo.`,
    },
];

@Injectable()
export class HomeService {
    apiUrl2 = `${environment.API_URL2}`;

    stats = [
        {
            title: "Total Sales",
            amount: "180,200",
            progress: {
                value: 50,
            },
            color: "bg-red-700",
        },
        {
            title: "Revenue",
            amount: "70,205",
            progress: {
                value: 70,
            },
            color: "bg-blue-500",
        },
        {
            title: "Traffic",
            amount: "1,291,922",
            progress: {
                value: 80,
            },
            color: "bg-green-500",
        },
        {
            title: "New User",
            amount: "1,922",
            progress: {
                value: 40,
            },
            color: "bg-purple-500",
        },
    ];

    charts = [
        {
            chart: {
                height: 350,
                type: "area",
                toolbar: false,
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
            },
            series: [
                {
                    name: "UV",
                    data: [31, 40, 28, 51, 42, 109, 100],
                },
                {
                    name: "Download",
                    data: [11, 32, 45, 32, 34, 52, 41],
                },
            ],
            xaxis: {
                type: "datetime",
                categories: [
                    "2019-11-24T00:00:00",
                    "2019-11-24T01:30:00",
                    "2019-11-24T02:30:00",
                    "2019-11-24T03:30:00",
                    "2019-11-24T04:30:00",
                    "2019-11-24T05:30:00",
                    "2019-11-24T06:30:00",
                ],
            },
            tooltip: {
                x: {
                    format: "dd/MM/yy HH:mm",
                },
            },
            legend: {
                position: "top",
                horizontalAlign: "right",
            },
        },
        {
            chart: {
                height: 350,
                type: "radar",
            },
            series: [
                {
                    name: "Weekly Revenue",
                    data: [20, 100, 40, 30, 50, 80, 33],
                },
            ],
            labels: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],
            plotOptions: {
                radar: {
                    size: 140,
                    polygons: {
                        strokeColor: "#e9e9e9",
                        fill: {
                            colors: ["#f8f8f8", "#fff"],
                        },
                    },
                },
            },
            colors: ["#FF4560"],
            markers: {
                size: 4,
                colors: ["#fff"],
                strokeColor: "#FF4560",
                strokeWidth: 2,
            },
            tooltip: {
                y: {
                    formatter: (val: number) => {
                        return val;
                    },
                },
            },
            yaxis: {
                tickAmount: 7,
                labels: {
                    formatter: (val: number, i: number) => {
                        if (i % 2 === 0) {
                            return val;
                        } else {
                            return "";
                        }
                    },
                },
            },
        },
    ];

    constructor(private http: HttpClient) {}

    getData() {
        return ELEMENT_DATA;
    }

    getMessages() {
        return MESSAGES;
    }

    getCharts() {
        return this.charts;
    }

    getStats() {
        return this.stats;
    }

    getConsumptionBilledAmount(params) {
        return this.http.post(
            // `${this.apiUrl2}/report/getConsum_billedamt`,
            `${this.apiUrl2}/report/getConsum_billedamtbyuser_id`,
            params,
        );
    }

    getConsumptionReportbyuserid(userid: number, paramsData: any) {
        let url = `${this.apiUrl2}/report/getConsumptionReportbyuserid/${userid}`;

        let params = new HttpParams();

        if (paramsData.cpo_id && paramsData.cpo_id != "-1" ) {
            params = params.set("cpo_id", paramsData.cpo_id);
        }

        if (paramsData.station_id && paramsData.station_id != "-1") {
            params = params.set("station_id", paramsData.station_id);
        }

        // ✅ Body me remaining data
        const body = {
            start_date: paramsData.start_date,
            end_date: paramsData.end_date,
        };

        return this.http.post(url, body, { params });
    }
}
